import { createClient } from '@supabase/supabase-js'

// Use import.meta.env for Vite environment variables
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string

if (!supabaseUrl || !supabaseAnonKey) {
  // Updated error message for clarity
  throw new Error('VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY must be defined in your .env file')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
